import React, { memo } from 'react';
import { Box } from '@mui/material';

const getStyle = () => ({
  position: 'absolute',
  height: '25px',
  lineHeight: '25px',
  zIndex: '300',
  color: 'white',
  textShadow: 'black 0 1px 8px',
  whiteSpace: 'nowrap',
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'center',
});

const IntervalLabel = ({ labelText, top, left, children }) => {
  return (
    <Box
      style={getStyle()}
      sx={{
        top: top,
        left: left,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        {children} {labelText}
      </Box>
    </Box>
  );
};

export default memo(IntervalLabel);
